import i18next from 'i18next';

const getLang = (lang?: string): string => {
    const current = lang || i18next.language || (typeof window !== 'undefined' ? window.localStorage?.i18nextLng : 'pl');
    return (current || 'pl').toLowerCase();
};

export const getContactUrl = (lang?: string): string => {
    const language = getLang(lang);
    return language.startsWith('pl')
        ? 'https://votenti.pl/kontakt'
        : 'https://votenti.com/contact';
};

export const getMarketingUrl = (lang?: string): string => {
    const language = getLang(lang);
    return language.startsWith('pl')
        ? 'https://votenti.pl/'
        : 'https://votenti.com/';
};
